import { Tooltip, makeStyles } from '@material-ui/core'
import { Close, ConfirmationNumber, DirectionsCar } from '@material-ui/icons'
import { AddRoad } from '@mui/icons-material'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useRefresh,
  useTranslate,
} from 'react-admin'
import { ResourceName } from '../../../../core/ResourceName'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { TerminalSetWorkingModeRequest } from '../../../../core/enum/TerminalSetWorkingModeRequest'
import { SetWorkingModeDialog } from '../TerminalDialogs'

const useStyles = makeStyles(() => ({
  iconContainer: {
    position: 'relative',
    width: 34,
  },
  icon: {
    position: 'absolute',
    left: 5,
    top: 5,
    fontSize: '24px !important',
  },
  crossIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 34,
    opacity: 0.8,
  },
}))

export const TerminalWorkingModeButton = ({ ...props }) => {
  const { jsonStatus, record, asRecurringJob } = props
  const translate = useTranslate()
  const classes = useStyles()
  const [mutate, { loading }] = useMutation()
  const hasAuthority = useHasAuthority()
  const refresh = useRefresh()

  const [workingModeDialogOpen, setWorkingModeDialogOpen] = useState(false)
  const [workingMode, setWorkingMode] = useState<
    TerminalSetWorkingModeRequest | undefined
  >(undefined)

  const handleOpenDialog = () => {
    setWorkingModeDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setWorkingModeDialogOpen(false)
  }

  const handleWorkingMode = () => {
    mutate({
      type: sanitizeFetchType('setWorkingMode'),
      resource: ResourceName.TERMINALS,
      payload: {
        terminalId: record?.id,
        workingMode,
      },
    })
    handleCloseDialog()
    refresh()
  }

  return (
    <div>
      <SetWorkingModeDialog
        open={workingModeDialogOpen}
        close={() => setWorkingModeDialogOpen(false)}
        workingMode={workingMode}
        setWorkingMode={setWorkingMode}
        handleWorkingMode={handleWorkingMode}
        asRecurringJob={asRecurringJob}
      />
      <Tooltip
        title={
          jsonStatus?.workingMode !== undefined
            ? translate(
                `resources.enums.WorkingMode.${jsonStatus?.workingMode}`,
              )
            : translate('resources.enums.WorkingMode.null')
        }
        onClick={
          !loading && hasAuthority(Authority.TERMINALS_SET_WORKING_MODE)
            ? handleOpenDialog
            : undefined
        }
      >
        <div
          className={classes.iconContainer}
          style={{
            cursor:
              !loading && hasAuthority(Authority.TERMINALS_SET_WORKING_MODE)
                ? 'pointer'
                : 'default',
          }}
        >
          {jsonStatus?.workingMode ===
            TerminalSetWorkingModeRequest.Standard && (
            <ConfirmationNumber className={classes.icon} />
          )}
          {jsonStatus?.workingMode ===
            TerminalSetWorkingModeRequest.LoopEnteringsOpens && (
            <AddRoad className={classes.icon} />
          )}
          {jsonStatus?.workingMode ===
            TerminalSetWorkingModeRequest.NonTicketWithPlates && (
            <DirectionsCar className={classes.icon} />
          )}
          {jsonStatus?.workingMode === undefined ||
            (jsonStatus?.workingMode === null && (
              <>
                <ConfirmationNumber className={classes.icon} />
                <Close fontSize="large" className={classes.crossIcon} />
              </>
            ))}
        </div>
      </Tooltip>
    </div>
  )
}
